import { render } from "./PaymentListPage.vue?vue&type=template&id=2f403504"
import script from "./PaymentListPage.vue?vue&type=script&lang=js"
export * from "./PaymentListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__